import React, { useState, useEffect } from "react";

import { useTranslation, Trans } from "react-i18next";

import Fade from "react-reveal/Fade";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts';

function DurabilityStatistics() {
  
  const { t } = useTranslation();

  const data = [
    { id: 'home.add.1', durability: 25 },
    { id: 'home.add.2', durability: 35 },
    { id: 'home.add.3', durability: 70 },
    { id: 'home.add.4', durability: 95 },
    { id: 'home.add.5', durability: 135 },
  ];

  const CustomTooltip = ({ active, payload }) => {
    const { t } = useTranslation();
  
    if (active && payload && payload.length > 0) {
      const item = payload[0];
      const labelId = item.payload.id;
      const durability = item.value;
  
      return (
        <div className="bg-white text-sm text-black shadow-md rounded px-2 py-1">
          <p dangerouslySetInnerHTML={{ __html: t(labelId) }} />
          <p>
            {t('home.add.7')}: {durability}
          </p>
        </div>
      );
    }
  
    return null;
  };

  const [barSize, setBarSize] = useState(131);

  useEffect(() => {
    const handleResize = () => {
      setBarSize(window.innerWidth <= 768 ? 50 : 131);
    };

    handleResize(); // при первом рендере

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
      <div className="max-w-[1220px] xl:mx-auto">
        <div className="flex items-center justify-center">
          <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
            <Trans>{t("home.53")}</Trans>
          </p>
        </div>
        <div className="w-full overflow-x-auto pb-[10px]">
        <div className="w-[700px] ml-[-30px] md:ml-0 xl:w-full h-[400px] xl:h-[500px] p-6 rounded-lg open-sans text-white">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
              <CartesianGrid stroke="#444" />
              <XAxis
                dataKey="id"
                interval={0}
                tick={({ x, y, payload }) => {
                  const label = t(payload.value);
                  return (
                    <foreignObject x={x - 57} y={y-4} width={120} height={40}>
                      <div
                        className="text-white text-[12px] font-[300] text-center leading-tight"
                        style={{ whiteSpace: 'pre-line' }}
                        dangerouslySetInnerHTML={{ __html: label }}
                      />
                    </foreignObject>
                  );
                }}
              />
              <YAxis label={{ value: 'Years', dx: 18, dy: 15, position: 'bottom', fill: '#fff' }} className="text-[12px] font-[300]" tick={{ fill: '#fff' }} />
              <Tooltip content={<CustomTooltip />} cursor={false} />   
              <Bar dataKey="durability" fill="#F26522" radius={[5, 5, 0, 0]} activeBar={{ fill: '#d4541e' }} barSize={barSize}/>
            </BarChart>
          </ResponsiveContainer>
          <div className="w-[calc(100%-60px)] mx-auto h-[2px] bg-[#4B4B4B] mt-[10px]"></div>
          
        </div>
        <p className="pl-[25px] xl:pl-[55px] text-[12px] open-sans text-white">{t('home.add.6')}</p>
        </div>
      </div>
    </div>
  );
}

export default DurabilityStatistics;
